import { createTheme, createVariant, globalTheme } from '@clds/component-theme';
export const textFieldTheme = createTheme({
    background: {
        color: {
            base: globalTheme.palette.surfaceAlt,
        },
    },
    border: {
        color: {
            base: globalTheme.palette.secondaryAlt,
            none: globalTheme.palette.secondaryAlt,
            error: globalTheme.palette.error,
            focus: globalTheme.palette.primary,
            hover: globalTheme.palette.primary,
            success: globalTheme.palette.success,
            warning: globalTheme.palette.warning,
        },
        radius: globalTheme.radius.lg,
        width: '1px',
    },
    color: {
        base: globalTheme.palette.secondaryAlt,
    },
    input: {
        color: {
            base: globalTheme.palette.contrastHigh,
            placeholder: globalTheme.palette.secondaryAlt,
        },
        decorationMargin: globalTheme.spacing.xxs,
        padding: {
            md: '0.6rem',
            xs: '0.375rem',
        },
    },
    outline: {
        color: {
            base: globalTheme.palette.primary,
        },
    },
}, 'text-field');
export const borderColorVariant = createVariant((props) => textFieldTheme.border.color[props.validationState]);
//# sourceMappingURL=theme.js.map